export enum ServicesActionType {
  FETCH_SERVICES = "FETCH_SERVICES",
  FETCH_SERVICES_START = "FETCH_SERVICES_START",
  FETCH_SERVICES_SUCCESS = "FETCH_SERVICES_SUCCESS",
  FETCH_SERVICES_FAIL = "FETCH_SERVICES_FAIL"
}
